import { TextField } from '@bingads-webui-react/fluent-controls';

import { withRemainingCharsUnvalidated } from './with-remaining-chars-unvalidated';

export const RemainingCharsUnvalidatedTextField = withRemainingCharsUnvalidated(TextField);
